function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#79A5FF",
  d: "M20.312 39.605h39.873l7.512-22.813z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M82.98 9.434h39.149l7.996 22.812z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M67.697 16.792v22.813h-7.512z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#79A5FF",
  d: "M67.697 16.792l34.854 36.406.004-34.29z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4FF",
  d: "M82.98 9.434h39.149L102.555 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M67.697 16.792l34.858 2.12L82.98 9.435z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4FF",
  d: "M67.697 16.792v66.92l34.854-30.514zM20.312 39.605L53.405 72.35l14.292-32.746z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#79A5FF",
  d: "M67.697 39.605v75.109L53.405 72.35zM53.405 72.35L20.312 39.606 12.835 72.35z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M67.697 114.714l34.854-61.516-34.854 30.514z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4FF",
  d: "M53.405 72.35l-9.4 20.021 23.692 22.343z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#79A5FF",
  d: "M44.004 92.371L5.34 105.19l7.495-32.838z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M12.835 72.35l31.17 20.021 9.4-20.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M0 128.595l44.004-36.224L5.34 105.19z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4FF",
  d: "M102.555 53.198l27.57-20.952-27.57-13.338z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4FF",
  d: "M130.125 32.246l30.95-4.073L122.13 9.434z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M102.551 53.198l27.574 17.898 30.95-42.923-30.95 4.073z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2C60C8",
  d: "M98.911 92.905l31.214-21.81-27.574-17.897z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M89.366 99.565l-4.24 36.382 45-39.238-21.871-10.34z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D55A5",
  d: "M85.124 135.947l-17.427 19.928-43.431-32.253 43.43-8.908zM0 128.595l24.266-4.973-2.517 32.253z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M21.749 155.875h45.948l-26.943-20.012z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M24.266 123.622l-2.517 32.253 19.005-20.012z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#234A96",
  d: "M45.31 155.875H21.749l11.96 14.988z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D52BB",
  d: "M40.754 170.863h13.941l13.002-14.988H45.31z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M33.708 170.863h7.046l4.556-14.988z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M54.695 170.863l2.217 29.097-23.204-29.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D4493",
  d: "M54.695 170.863h30.43v-34.916z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#234A96",
  d: "M85.126 170.863H54.695l2.217 29.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D55A5",
  d: "M130.125 71.096v25.613l32.611-25.613z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M130.125 71.096h61.854l-7.188-31.491z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M130.125 96.71l16.306 15.943 16.305-41.557z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D55A5",
  d: "M85.126 135.947l61.305-23.294-16.306-15.944z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D52BB",
  d: "M146.43 112.653l43.53-19.12 2.02-22.437h-29.244z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M189.96 93.532l2.02-22.436 5.125 22.436z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D52BB",
  d: "M189.96 93.532l-10.437 19.121 22.42 2.052-4.838-21.173z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M179.523 112.653h-33.092l43.528-19.12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D4493",
  d: "M162.736 112.653l-29.18 27.096-48.43-3.802 61.305-23.294z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M133.556 139.749l45.967-27.096h-16.787z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M85.126 170.863l25.917-32.88-25.917-2.036z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D4493",
  d: "M109.341 155.875l24.215-16.126-22.513-1.766z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D52BB",
  d: "M109.341 155.875l1.702-17.892-25.917 32.88z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M179.523 112.653l10.436 22.641 15.144-6.699-3.16-13.89z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D4493",
  d: "M189.96 135.294l15.143-6.699-15.144 18.999z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M189.96 147.594l-27.224-25.031 16.787-9.91z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M179.523 112.653l10.436 22.641v12.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D4493",
  d: "M133.556 139.749l56.403 7.845-27.223-25.031z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D52BB",
  d: "M133.556 139.749l22.984 17.835v-14.64z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M156.54 157.584h25.444l7.975-9.99-33.42-4.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D55A5",
  d: "M156.54 157.584h25.444l-12.722 15.956z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M156.54 157.584v31.927l12.722-15.97z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D52BB",
  d: "M85.126 170.863l-6.299 29.097H56.912z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M85.124 170.863h33.349l18.922-13.28h-30.808z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D55A5",
  d: "M137.395 157.584l-13.138-11.635-17.67 11.635z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D4493",
  d: "M137.395 157.584l-3.839-17.835-9.3 6.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#234A96",
  d: "M156.54 157.584h-19.145l-3.839-17.835z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M78.827 199.96l39.646-29.097H85.126z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M78.827 199.96h27.76l-4.036-17.393z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M148.191 199.96l8.349-42.376v31.927z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M156.54 157.584h-19.145l10.796 42.376z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D4493",
  d: "M148.191 199.96l-29.718-29.097 18.922-13.28zM118.473 170.863l-11.886 29.097-4.036-17.393z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M106.587 199.96h41.604l-17.759-17.393z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D55A5",
  d: "M106.587 199.96l11.886-29.097 11.96 11.704z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M108.255 86.37l21.87-15.274v25.613z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#79A5FF",
  d: "M67.697 114.705l31.214-21.8-10.027-15.548z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#79A5FF",
  d: "M88.884 77.357l10.027 15.548 3.644-39.707z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D55A5",
  d: "M130.125 71.096l30.927-42.898 7.108 20.972z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M168.16 49.17l16.631-9.565-23.715-11.407zM85.126 135.863l4.24-36.298-21.67 15.149z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2C60C8",
  d: "M0 128.595l44.004-36.224 23.693 22.343z"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.858,
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M95.003 2.93l.464.186-9.15 22.654c.394.24.713.592.91 1.013l35.726-17.852.224.448-35.785 17.88a2.366 2.366 0 01.047.771l63.254 4.073a2.356 2.356 0 01.823-1.418l-6.962-10.543.418-.276 6.961 10.543c.255-.132.536-.219.834-.25v-6.072h.5v6.072a2.36 2.36 0 012.016 1.687l10.898-1.947.088.493-10.899 1.945a2.349 2.349 0 01-.53 1.664l23.128 23.541a2.348 2.348 0 012.184-.398l5.423-13.477.464.186-5.43 13.493a2.358 2.358 0 011.182 2.08l8.194 1.034-.062.496-8.192-1.034c-.11.475-.362.895-.71 1.212l13.447 19.548-.412.283-13.439-19.534a2.344 2.344 0 01-.57.237l7.283 45.84.122-.004c1.218 0 2.22.923 2.345 2.108h10.952v.5l-10.952.001a2.36 2.36 0 01-1.455 1.934l8.057 27.935-.48.138-8.057-27.935a2.373 2.373 0 01-1.046-.05l-19.49 48.943c.455.24.823.626 1.04 1.096l13.532-4.588.16.473-13.531 4.588a2.367 2.367 0 01-.32 1.798l5.194 4.2-.314.388-5.195-4.2c-.371.37-.865.619-1.416.677v12.42h-.5v-12.42a2.357 2.357 0 01-1.696-1.012l-24.122 11.118a2.356 2.356 0 01-.522 2.377l13.572 15.895-.38.325-13.572-15.895c-.328.225-.716.37-1.135.404l-.481 21.2-.5-.01.48-21.2a2.355 2.355 0 01-1.509-.83l-33.383 22.283-.278-.416 33.384-22.283a2.342 2.342 0 01-.22-.616l-81.653 8.032a2.349 2.349 0 01-.56 1.506l12.77 13.396-.363.345-12.768-13.396a2.348 2.348 0 01-1.437.488l.035-.002-.64 5.944-.497-.054.64-5.933a2.36 2.36 0 01-1.884-2.063h-4.54v-.5h4.54a2.36 2.36 0 011.195-1.81L19.275 109.76a2.358 2.358 0 01-2.256-.491L1.112 123.764l-.337-.37L16.682 108.9a2.348 2.348 0 01-.432-1.74l-10.978-2.841.125-.485 10.978 2.841a2.364 2.364 0 011.561-1.439l-5.603-32.33.492-.086 5.604 32.331.155-.005c.347 0 .676.075.973.21l25.924-44.07c-.466-.345-.8-.859-.912-1.45l-29.413 2.44-.042-.499 29.414-2.44a2.353 2.353 0 01.803-1.719L29.465 35.096l.409-.288 15.866 22.52a2.348 2.348 0 011.317-.29l6.097-33.677.492.09-6.096 33.676c.38.111.72.316.994.586l34.745-28.406a2.35 2.35 0 01-.554-1.52c0-.547.186-1.05.498-1.45l-10.36-12.304.383-.322 10.328 12.264a2.349 2.349 0 012.279-.418l9.14-22.628zm2.064 156.653a2.358 2.358 0 01-3.93.313l-39.256 24.353c.012.045.022.09.032.135l81.652-8.031c.002-.227.036-.446.097-.654zm-36.874-18.26a2.357 2.357 0 01-2.078 1.085l-5.856 40.188c.624.181 1.142.613 1.437 1.18l39.177-24.306a2.35 2.35 0 01-.084-1.849zm-39.956-32.137c-.15.147-.318.274-.502.377l31.176 73.044a2.358 2.358 0 01.855-.097l5.854-40.174a2.36 2.36 0 01-1.384-3.58zm92.63-1.742L96 156.312a2.359 2.359 0 011.259 2.808l38.596 16.116c.24-.436.614-.788 1.067-1l-23-66.791a2.366 2.366 0 01-1.057 0zm38.465 30.151a2.359 2.359 0 01-.969.08l-11.498 36.534c.453.197.832.533 1.083.953l24.093-11.106a2.355 2.355 0 01.745-2.76zm-36.656-30.469c-.09.058-.183.11-.28.156l23 66.79a2.366 2.366 0 01.993-.013l11.487-36.5a2.36 2.36 0 01-1.21-3.486zm42.882-8.12l-6.23 34.066a2.36 2.36 0 01.47 4.328l13.414 23.634c.142-.068.291-.121.447-.16l-7.934-61.86c-.056 0-.112-.003-.167-.007zm1.982-.834c-.333.396-.793.68-1.318.791l7.932 61.845.071-.002c.22 0 .433.03.635.086l19.491-48.943a2.358 2.358 0 01-1.154-2.78zm-47.98 8.455l-51.045 32.94a2.369 2.369 0 01-.099 1.31l32.597 16.298a2.357 2.357 0 012.515-1.027l16.865-48.867a2.367 2.367 0 01-.833-.654zM79.119 90.284a2.358 2.358 0 01-2.63 1.11l-17.338 46.495c.533.233.963.658 1.203 1.186l50.935-32.868a2.349 2.349 0 01-.14-1.78zM45.91 61.54l-25.924 44.07a2.355 2.355 0 01.569 3.189l35.997 29.571c.295-.29.665-.502 1.079-.606L46.963 61.746l-.077.003a2.35 2.35 0 01-.975-.21zm2.482-.334a2.351 2.351 0 01-.933.474l10.668 76.015.078-.001c.16 0 .316.016.467.046l17.348-46.52a2.358 2.358 0 01-.621-3.772zm107.088 36.147l-39.735 7.598a2.35 2.35 0 01-.671 1.852l33.902 26.88a2.351 2.351 0 011.858-.7l6.231-34.065a2.364 2.364 0 01-1.585-1.565zm23.052-35.78l-19.395 33.187a2.355 2.355 0 01.686 2.991l25.57 10.958a2.364 2.364 0 011.443-1.123l-7.284-45.84-.12.004c-.319 0-.622-.063-.9-.177zm-51.992-.25a2.348 2.348 0 01-1.698.402l-10.621 41.212c.683.256 1.216.82 1.43 1.522l39.733-7.598a2.35 2.35 0 01.615-1.802zm-3.217-.486L79.2 88.087a2.35 2.35 0 01.12 1.739l32.03 14.143a2.358 2.358 0 012.387-1.157L124.36 61.6a2.365 2.365 0 01-1.035-.764zm53.763-1.196h-49.554a2.35 2.35 0 01-.615 1.353l29.457 33.735a2.348 2.348 0 011.36-.432c.346 0 .676.075.972.21l19.386-33.174a2.357 2.357 0 01-1.006-1.692zM86.791 29.424a2.352 2.352 0 01-1.73.721l-7.434 56.67a2.36 2.36 0 011.31.846L123.06 60.41a2.35 2.35 0 01-.231-1.018c0-.462.133-.893.362-1.257zm-3.137.232L48.859 58.099c.243.37.385.815.385 1.292 0 .549-.187 1.054-.502 1.454L75.79 87.13a2.347 2.347 0 011.342-.38l7.434-56.664a2.349 2.349 0 01-.911-.43zm67.85 4.657l-24.456 23.628c.264.338.437.75.485 1.2h49.554c.05-.472.239-.902.525-1.249l-23.129-23.54c-.402.32-.911.51-1.465.51a2.349 2.349 0 01-1.514-.549zm-64.17-5.789a2.347 2.347 0 01-.236.505l36.403 28.714a2.351 2.351 0 011.687-.71c.575 0 1.103.206 1.512.548l24.457-23.628a2.348 2.348 0 01-.498-1.449l.003.098z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M285.808 164c7.5 0 13.5-5.994 13.5-13.338V137.31c.02-.368.307-7.288-4.8-16.62l-12.9-24.277s-4.65-7.942-4.65-14.087v-10.04c0-3.297 2.55-5.845 5.7-5.845 3.15 0 5.7 2.548 5.7 5.845v12.138c2.85-1.199 7.05-3.147 7.95-3.596 1.35-.75 3-2.398 3-5.845v-4.046c0-7.193-5.85-13.787-13.05-13.937h-6.75c-7.499 0-13.498 6.594-13.498 13.937l-.001 10.805c-.02.367-.307 7.288 4.8 16.62l12.9 24.127s4.65 8.092 4.65 14.236v11.99c0 3.296-2.55 5.844-5.7 5.844-3.15 0-5.7-2.548-5.7-5.695v-18.283c-2.7 1.2-7.05 3.147-7.95 3.447-1.35.75-3 2.398-3 5.845v10.79c.15 7.193 5.85 13.037 13.05 13.337h6.75zm90.744 0c7.2-.3 12.899-6.144 12.899-13.338v-25.326c-2.7 1.199-6.9 2.997-7.8 3.447-1.35.75-2.85 2.398-2.85 5.844v14.087c0 3.297-2.55 5.845-5.849 5.845-3.15 0-5.7-2.548-5.7-5.845V72.136a5.695 5.695 0 015.7-5.695c3.3 0 5.85 2.548 5.85 5.695v23.528l7.8-3.597c1.349-.6 2.849-2.248 2.849-5.694V70.338c0-7.194-5.7-13.188-12.9-13.338h-6.599c-7.5 0-13.499 5.994-13.499 13.338v80.324c0 7.344 6 13.338 13.5 13.338h6.599zm79.044-1.049v-48.105h11.7c1.35 0 2.4 1.049 2.55 2.398v45.707h10.798V62.245c0-1.798-1.05-4.196-4.35-4.196h-6.449v46.157h-10.5c-2.549 0-3.749-.75-3.749-3.747V58.05h-6.45c-3.3 0-4.349 2.398-4.349 4.196v100.706h10.8zm108.892 0c3.45 0 5.1-1.499 5.85-2.847.45-.9 2.25-5.096 3.45-7.793h-22.499v-36.416c0-1.349 1.2-2.548 2.55-2.548h4.5c3.45 0 4.95-1.498 5.7-2.847.45-.9 2.25-5.245 3.45-7.943h-16.2v-31.17c0-1.499 1.05-2.548 2.55-2.548h8.7c3.45 0 5.1-1.649 5.7-2.997l3.599-7.793H543.79a3.28 3.28 0 00-3.3 2.997v101.905h23.998zm66.746 0v-54.1l6.3 27.425c.6 2.248 1.8 8.542 8.099 8.542h3.3l8.099-35.966v54.099h10.65V58.049h-6.6c-3.9 0-4.65 3.297-4.8 3.747l-11.85 60.393-12.448-60.244s-.6-3.896-4.8-3.896h-6.6v104.902h10.65zm91.943 0l9.45-72.233 9.449 72.233h11.849l-15.149-99.207c-.45-2.848-1.2-5.695-5.7-5.695h-5.85l-15.898 104.902h11.85zm89.394 0v-48.105h11.699c1.35 0 2.4 1.049 2.55 2.398v45.707h10.8V62.245c0-1.798-1.05-4.196-4.35-4.196h-6.45v46.157h-10.5c-2.55 0-3.75-.75-3.75-3.747V58.05h-6.449c-3.3 0-4.35 2.398-4.35 4.196v100.706h10.8zm108.892 0c3.45 0 5.1-1.499 5.85-2.847.45-.9 2.25-5.096 3.45-7.793h-22.499v-36.416c0-1.349 1.2-2.548 2.55-2.548h4.5c3.45 0 4.95-1.498 5.7-2.847.45-.9 2.249-5.245 3.449-7.943h-16.199v-31.17c0-1.499 1.05-2.548 2.55-2.548h8.7c3.449 0 5.099-1.649 5.699-2.997l3.6-7.793h-28.048a3.28 3.28 0 00-3.3 2.997v101.905h23.998zm72.295 0v-45.108h5.7c2.85 0 5.55 1.649 5.55 6.744v38.364h10.798l.001-40.19c.015-.512.152-7.839-3.9-9.863 4.273-1.03 3.914-9.005 3.9-9.284V71.237c0-7.343-6-13.188-13.2-13.188H982.96v104.902h10.799zm5.7-55.298h-5.7V68.09h5.7c2.85 0 5.55 1.498 5.55 5.395v28.173c0 4.796-2.7 5.995-5.55 5.995zM1093.95 164c7.2-.3 12.899-5.994 13.049-13.188V70.338c0-7.194-5.85-13.038-13.05-13.338h-8.248c-7.5 0-13.5 5.994-13.5 13.338v80.474c.15 7.194 6.15 13.188 13.5 13.188h8.249zm-3.6-9.441h-1.65c-3.15-.15-5.7-2.698-5.7-5.845V72.286c0-3.147 2.55-5.695 5.7-5.845h1.65c3.15 0 5.7 2.548 5.7 5.845v76.428c0 3.297-2.55 5.845-5.7 5.845z",
  fill: "#326DE6",
  fillRule: "nonzero"
}));

var SvgSchemaheroSmall = function SvgSchemaheroSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 48,
    viewBox: "0 0 1107 201"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/schemahero-small.035b95f4.svg";
export { SvgSchemaheroSmall as ReactComponent };